import React from 'react';
import { CloudIcon, MonitorIcon, PhoneIcon, ShieldIcon } from './ui/Icons';
import type { PillarId } from '../data/services';

const ICONS: Record<PillarId, React.FC<{ size?: number }>> = {
  websites: MonitorIcon,
  mobile: PhoneIcon,
  cloud: CloudIcon,
  security: ShieldIcon,
};

const PillarIcon: React.FC<{ id: PillarId; size?: number }> = ({ id, size }) => {
  const Icon = ICONS[id];
  return <Icon size={size} />;
};

export default PillarIcon;
